import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Dialog} from "@mui/material"
import {useCallback, useContext} from "react"
import {BackendContext} from "../../../context/BackendContext"
import styles from "./index.module.scss"
import {faCrown} from "@fortawesome/free-solid-svg-icons"

interface DownloadDesktopAppProps {
  open: boolean
  onClose: () => void
}

export const DownloadDesktopApp = (props: DownloadDesktopAppProps) => {
  const {open, onClose} = props
  const {ipfs} = useContext(BackendContext)

  const onClickDownload = useCallback(async () => {
    if (!ipfs) {
      return
    }
    // TODO: download desktop app from CID using IPFS
  }, [ipfs])

  return (
    <Dialog open={open}
            onClose={onClose}
            PaperProps={{className: styles.Container}}
    >
      <div className={styles.Header}>
        Download DeGit Desktop
      </div>

      <div className={styles.Row}>
        <div className={styles.RowItem}>
          <FontAwesomeIcon icon={faCrown} className={styles.Icon}/>
          <div>Full Git support</div>
        </div>
        <div className={styles.RowItem}>
          <FontAwesomeIcon icon={faCrown} className={styles.Icon}/>
          <div>Earn token rewards</div>
        </div>
        <div className={styles.RowItem}>
          <FontAwesomeIcon icon={faCrown} className={styles.Icon}/>
          <div>Quick repo access</div>
        </div>
      </div>

      <div className={styles.Remark}>
        Onchain request is a feature for end users to make feature requests with
        cryptocurrency incentive. You need to download “DeGit Desktop” for activating
        the feature.
      </div>

      <button className={styles.DownloadButton}
              onClick={onClickDownload}
      >
        Download Now
      </button>

    </Dialog>
  )
}
